export default {
	title: 'Sensor Self Diagnosis',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful',
		requiredError: 'Required field cannot be empty'
	},
	buttons: {
		add: 'Add',
		batchDelete: 'Batch Delete',
		edit: 'Edit',
		delete: 'Delete',
		export: 'Export',
		exporting: 'Exporting',
		diagnose: 'Diagnose'
	},
	table: {
		projectNo: 'Project No',
		deviceName: 'Device Name',
		pointName: 'Point Name',
		sensorNo: 'Sensor No',
		sensorStatus: 'Sensor Status',
		onlineStatus: 'Online Status',
		abnormalCause: 'Abnormal Cause',
		lastEigenTime: 'Latest Eigen Value',
		lastWaveTime: 'Latest Wave',
		collectionData: 'Latest Collection Data',
		action: 'Action'
	},
	form: {
		placeholder: {
			name: 'Point Name',
			projNo: 'Project No',
			pointNo: 'Sensor No',
			deviceName: 'Device Name',
			sensorStatus: 'Sensor Status',
			onlineStatus: 'Online Status',
			orgId: 'Organization (Diagnosis)',
			device: 'Device Selection'
		},
		label: {
			project: 'Project',
			pointName: 'Point Name',
			model: 'Model',
			org: 'Organization (Diagnosis)',
			device: 'Device',
			direction: 'Installation Direction',
			pointNo: 'Point No',
			sort: 'Sort',
			diagnoseGroup: 'Status Evaluation Model Group'
		},
		options: {
			normal: 'Normal',
			abnormal: 'Abnormal',
			online: 'Online',
			offline: 'Offline'
		}
	},
	config: {
		gridLayout: 'Grid Layout'
	},
	dialog: {
		add: 'Add',
		update: 'Edit'
	}
}
